import NextHead from 'next/head'
import { useMetaTranslation } from '@/scopes/common/components/useMetaTranslation'

interface MetaDescriptionProps {
  descriptionTranslationTag: string
  descriptionTranslationValues?: Record<string, string>
}

export function MetaDescription({ descriptionTranslationTag, descriptionTranslationValues }: MetaDescriptionProps) {
  const description = useMetaTranslation(descriptionTranslationTag, descriptionTranslationValues, 'description')

  return (
    <NextHead>
      <meta name="description" content={description} />
    </NextHead>
  )
}
